<template>
    <div class="trans-data">
        <div class="trans-data_filter">
            <el-date-picker
                v-model="filterParams.time"
                :clearable="false"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                popper-class="date-no-light"
                @change="handleDateChange"
            >
            </el-date-picker>

            <div
                :class="['time-item', { 'is-check': filterParams.timeIndex === item.index }]"
                v-for="item in timeOption"
                :key="item.index"
                @click="handleCheckTime(item.index)"
            >
                {{ item.label }}
            </div>
        </div>

        <div class="trans-data_overview">
            <div class="overview-item" v-for="item in overviewOptions" :key="item.index">
                <div class="item-label">
                    {{ item.label }}

                    <el-popover placement="top" width="200" trigger="hover" popper-class="dark-popover" :content="item.tip">
                        <i class="iconfont" slot="reference">&#xe61d;</i>
                    </el-popover>
                </div>
                <div class="item-value">{{ item.value }}{{ item.unit ? item.unit : "" }}</div>
            </div>
        </div>

        <div class="trans-data_trend">
            <div class="trend-filter">
                <span>数据趋势</span>

                <el-select v-model="filterParams.trendIndex" size="small" placeholder="请选择" @change="setTrendChart">
                    <el-option v-for="item in overviewOptions" :key="item.index" :label="item.label" :value="item.index"> </el-option>
                </el-select>
            </div>

            <div class="trend-chart" ref="trendChartRef"></div>
        </div>

        <div class="trans-data_table">
            <div class="table-title">分日期会话数据</div>

            <el-table
                :data="tableData"
                style="
                            width: 100%;
                            flex: 1;
                            border-radius: 4px;
                        "
                size="medium"
                :header-cell-style="{
                    fontWeight: 'normal',
                    color: '#333',
                    background: '#eef2fa',
                }"
                :cell-style="{ fontSize: '12px', color: '#333' }"
            >
                <el-table-column prop="date" label="日期"> </el-table-column>
                <el-table-column prop="robot_message_count" align="right" label="机器会话数量"> </el-table-column>
                <el-table-column prop="change" align="right" label="转人工量"> </el-table-column>
                <el-table-column prop="change_rate" align="right" label="转人工率"> </el-table-column>
                <el-table-column prop="retention" align="right" label="机器直接留资数"> </el-table-column>
                <el-table-column prop="retention_rate" align="right" label="机器直接留资率" width="180"> </el-table-column>
            </el-table>

            <div class="table-pagination">
                <el-pagination
                    background
                    size="small"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="pageParams.page"
                    :page-size="1000"
                    layout="prev, pager, next, jumper"
                    :total="tableData.length"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TransData",
    data() {
        return {
            pageParams: {
                page: 1,
            },
            filterParams: {
                timeIndex: 2,
                time: [],
                trendIndex: 1,
            },
            timeOption: [
                { index: 1, label: "昨天" },
                { index: 2, label: "近7天" },
                { index: 3, label: "近15天" },
            ],
            // 日期不能选择今天以及今天以后的
            pickerOptions: {
                disabledDate(time) {
                    const date = new Date();
                    date.setDate(date.getDate() - 1);
                    return time.getTime() > date.getTime();
                    // return time.getTime() > Date.now()
                },
            },
            overviewOptions: [
                { index: 1, label: "机器人会话量", value: 0, tip: "选择日期内，由用户发起会话且分配机器人客服的会话数量" },
                { index: 2, label: "机器人有效会话量", value: 0, tip: "选择日期内，由用户发起会话且产生过提问的会话数量" },
                { index: 3, label: "机器人转人工量", value: 0, tip: "选择日期内，在机器人会话量中，机器人请求转人工的会话量" },
                { index: 4, label: "机器人转人工率", value: 0, tip: "机器人转人工量/机器人会话量", unit: "%" },
                { index: 5, label: "机器人直接留资数", value: 0, tip: "机器人会话中产生的直接留资数" },
                { index: 6, label: "机器人直接留资率", value: 0, tip: "机器人直接留资数/机器人会话量", unit: "%" },
                { index: 7, label: "机器人参与留资数", value: 0, tip: "机器人转人工量中产生的直接留资数" },
                { index: 8, label: "机器人参与留资率", value: 0, tip: "机器人产于留资数/机器人会话量", unit: "%" },
                { index: 9, label: "机器人服务评价分", value: 0, tip: "有服务评分会话的评分之和/有服务评分的机器人会话数" },
            ],
        };
    },
    created() {
        this.setFilterTime();
    },
    mounted() {
        this.setTrendChart();
    },
    computed: {
        tableData() {
            const data = [];
            const dateLabels = this.getDateRangeLabels(this.filterParams.time, 2).reverse();
            dateLabels.forEach((date) => {
                data.push({
                    date: date,
                    robot_message_count: 0,
                    change: 0,
                    change_rate: "0%",
                    retention: 0,
                    retention_rate: "0%",
                });
            });

            return data;
        },
    },
    methods: {
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },

        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        },

        handleCheckTime(index) {
            this.filterParams.timeIndex = index;
            this.setFilterTime();
        },

        setFilterTime() {
            const timeDayMap = {
                1: 0,
                2: 7,
                3: 15,
            };

            const date = new Date(new Date().setDate(new Date().getDate() - 1));
            const prevDate = new Date(new Date().setDate(date.getDate() - timeDayMap[this.filterParams.timeIndex]));

            this.filterParams.time = [prevDate, date];
            this.setTrendChart();
        },

        handleDateChange() {
            this.filterParams.timeIndex = 0;
            this.setTrendChart();
        },

        getDateRangeLabels([startDate, endDate], type = 1) {
            if (!startDate || !endDate) return [];

            let labels = [];
            let currentDate = new Date(startDate);

            while (currentDate <= new Date(endDate)) {
                labels.push(this.formatDate(currentDate, type)); // 格式化日期
                currentDate.setDate(currentDate.getDate() + 1); // 日期 +1
            }

            return labels;
        },

        formatDate(date, type) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const day = date
                .getDate()
                .toString()
                .padStart(2, "0");
            return type === 1 ? `${month}.${day}` : `${year}-${month}-${day}`; // 格式化为 "YYYY-MM-DD"
        },

        //  图表
        setTrendChart() {
            if (!this.$refs.trendChartRef) return;

            const timeLabels = this.getDateRangeLabels(this.filterParams.time);
            const data = new Array(timeLabels.length).fill(0);

            const chart = this.$echarts.init(this.$refs.trendChartRef);
            const label = this.overviewOptions[this.filterParams.trendIndex - 1].label;
            const unit = this.overviewOptions[this.filterParams.trendIndex - 1].unit;

            const options = {
                grid: {
                    top: 20,
                    left: 40,
                    bottom: 20,
                    right: 15,
                },
                tooltip: {
                    trigger: "axis",
                    borderWidth: 0,
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                    extraCssText: "box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.3)",
                    textStyle: {
                        color: "#323233",
                    },
                    formatter: function(params) {
                        const value = params[0];

                        return `
                            <div class="time-tooltip">
                                <div class="time-label">${value.axisValue}</div>

                                <div class="time-value">
                                    <div class="icon">
                                        <i></i>${label}：
                                    </div>

                                    <span>${value.data}${unit ? unit : ""}</span>
                                </div>
                            </div>
                        `;
                    },
                },
                xAxis: {
                    type: "category",
                    // boundaryGap: false, // 避免额外间隙
                    data: timeLabels,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            type: "dashed",
                            color: "#999999",
                        },
                    },
                    axisLabel: {
                        // interval: 0,
                    },
                },
                yAxis: {
                    type: "value",
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: false,
                    },
                },
                series: [
                    {
                        data: data,
                        type: "line",
                        showSymbol: false,
                        smooth: true,
                        lineStyle: {
                            color: "#f64e24",
                        },
                        symbol: "circle",
                        itemStyle: {
                            color: "#f64e24", // 数据点颜色（如蓝色）
                            borderWidth: 0, // 边框宽度
                        },
                    },
                ],
            };

            chart.clear();
            chart.setOption(options);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .time-tooltip {
    width: 180px;
    height: 60px;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    padding: 12px;
    gap: 6px;

    .time-value {
        display: flex;
        justify-content: space-between;
        width: 100%;

        i {
            width: 8px;
            height: 8px;
            background-color: #f64e24;
            border-radius: 50%;
            display: inline-block;
            margin-right: 6px;
        }
    }
}

.trans-data {
    background-color: #ffffff;
    min-height: 300px;

    &_filter {
        margin-top: 10px;
        display: flex;
        align-items: center;
        gap: 10px;

        .time-item {
            width: 88px;
            height: 29px;
            border-radius: 4px;
            border: 1px solid #dadadc;
            color: #161823bf;
            background-color: #ffffff;
            text-align: center;
            line-height: 29px;
            cursor: pointer;

            &.is-check {
                color: #2a55e5;
                border-color: #2a55e5;
            }
        }
    }

    &_overview {
        display: flex;
        gap: 16px;
        flex-wrap: wrap;
        margin-top: 16px;

        .overview-item {
            width: 216px;
            height: 95px;
            background-color: #fafafb;
            border-radius: 4px;
            padding: 8px 16px;
            box-sizing: border-box;
            flex-shrink: 0;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .item-label {
                font-size: 14px;
                color: #16182357;

                .iconfont {
                    font-size: 14px;
                    display: inline-block;
                    line-height: 14px;
                    margin-left: 4px;
                    cursor: pointer;
                }
            }

            .item-value {
                color: #161823;
                font-size: 36px;
                font-weight: 600;
            }
        }
    }

    &_trend {
        margin-top: 24px;

        .trend-filter {
            span {
                margin-right: 10px;
            }
        }

        .trend-chart {
            height: 280px;
            // border: 1px solid rgba(0, 0, 0, 0.1);
        }
    }

    &_table {
        margin-top: 24px;
        margin-bottom: 24px;

        .table-pagination {
            margin-top: 20px;
            display: flex;
            justify-content: flex-end;
        }
    }
}
</style>
